<template>
    <div class="link-loading">
    </div>
</template>

<script>

    import Loading from 'yirous-loading'
    import 'yirous-loading/docs/lib/yirous-loading.css'

    let loadingTemplate = {};

    export default {
        name: "link-loading",
        props: {
            type: {type: String, default: 'alpha'},
        },
        data() {
            return {
                loading: null,
            }
        },
        methods: {},
        mounted() {
            if (!loadingTemplate[this.type]) {
                loadingTemplate[this.type] = Loading[this.type]()
            }
            this.loading = loadingTemplate[this.type].cloneNode(true)
            this.$el.appendChild(this.loading)
        },
        beforeDestroy() {
            this.loading.parentNode.removeChild(this.loading)
        }
    }
</script>

<style lang="scss">
    @include themeify {
        .link-loading {
            font-size: inherit;
            color: inherit;
        }
    }
</style>